<template>
	<section class="carousel" v-if="products && products.length">
		<div class="carousel__inner _cnt">
			<div class="carousel__top">
				<div class="carousel__title _h1">{{ title }}</div>
				<router-link
					:to="showAllLink"
					class="carousel__browse-all _btn-bordered"
				>
					{{ $t('Browse all') }}
				</router-link>
			</div>
			<div class="carousel__line _line"><span></span></div>
			<Transition>
				<div v-if="products && products.length" class="carousel__slider">
					<swiper
						ref="swiperRef"
						:modules="modules"
						:slides-per-view="'auto'"
						:space-between="10"
						:free-mode="true"
					>
						<swiper-slide v-for="(item, i) in products" :key="i">
							<ProductCard
								:is-auth="isAuth"
								:item="item"
								:chosenItem="chosenItem"
								:currencySymbol="currencySymbol"
								@goToProduct="goToProduct"
								@addToCart="addToCart"
							/>
						</swiper-slide>
					</swiper>
				</div>
			</Transition>
		</div>
	</section>
</template>

<script>
import ProductCard from '@/components/ProductCard.vue';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { mapGetters } from 'vuex';

export default {
	name: 'ProductCarusel',
	components: {
		ProductCard,
		Swiper,
		SwiperSlide,
	},
	props: {
		isAuth: {
			type: Boolean,
			required: true,
		},
		chosenItem: {
			type: String,
		},
		title: {
			type: String,
			required: true,
		},
		showAllLink: {
			type: String,
			default: '/products/all',
		},
		apiEndpoint: {
			type: String,
			required: true,
		},
		showArrows: {
			type: Boolean,
			default: false,
		},
		initialProducts: {
			type: Array,
			default: null,
		},
	},
	data() {
		return {
			products: [],
			swiperRef: null,
			modules: [Navigation],
		};
	},
	watch: {
		currencyCode() {
			this.fetchProducts();
		},
	},
	computed: {
		...mapGetters('app', ['currencyCode', 'currencySymbol']),
	},
	mounted() {
		if (this.initialProducts && this.initialProducts.length > 0) {
			this.products = this.initialProducts;
		} else {
			this.fetchProducts();
		}
		this.$nextTick(() => {
			if (this.$refs.swiperRef && this.$refs.swiperRef.swiper) {
				this.$refs.swiperRef.swiper.on('init', () => {
					this.swiperRef = this.$refs.swiperRef.swiper;
				});
			}
		});
	},
	methods: {
		addToCart(item) {
			this.$emit('addToCart', item);
		},
		fetchProducts() {
			this.$http
				.get(this.apiEndpoint)
				.then((res) => {
					this.products = res.data.payload;
				})
				.catch((res) => {
					if (res.response.status === 401) {
						this.openSignInModal();
					}
				});
		},
		goToProduct(item) {
			this.$emit('goToProduct', item);
		},
		slidePrev() {
			if (this.swiperRef) {
				this.swiperRef.slidePrev();
			}
		},
		slideNext() {
			if (this.swiperRef) {
				this.swiperRef.slideNext();
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@use '@/assets/styles/mixins' as *;
@use '@/assets/styles/media' as *;
@use '@/assets/styles/components/classes' as *;

//========================================================================================================================================================

.carousel {
	&__inner {
	}
	&__top {
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 25, 15);
		}
		@media (min-width: $md3) {
			display: flex;
			justify-content: center;
			gap: 20px;
		}
	}
	&__title {
		text-align: center;
		margin: 0px auto;
		@media (max-width: $md3) {
			&:not(:last-child) {
				margin-bottom: 15px;
			}
		}
	}
	&__browse-all {
		align-self: center;
		height: fit-content;
		width: fit-content;
		white-space: nowrap;
	}
	&__line {
		max-width: 710px;
		margin-left: auto;
		margin-right: auto;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 40, 20);
		}
	}
	&__slider {
	}
}

.swiper-slide {
	@include adaptiveValue('width', 330, 250);
	@include adaptiveValue('min-width', 330, 250);
	flex-shrink: 1 !important;
	display: flex;
	height: auto !important;
}
</style>
